import React, { useEffect, useState } from "react";
import { Dialog, Card, CardBody, Typography } from "@material-tailwind/react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { IoClose } from "react-icons/io5";
import avatar from "assets/altImage.png";

import Modal from "pages/Friends/components/Modal";
import { getAllFriends } from "store/services/Friends/friends";
import { shareList } from "store/services/Store/List";
import { getUserDashboard } from "store/services/Authentication";
import { setListItems, setLists } from "store/actions/Store/list";
import { getDashboard } from "store/actions/Authentication";
const ShareList = ({ isOpen, handleClose, shareListModalData, li }) => {
  const { user } = useSelector((store) => store.userReducer);
  const [getFriends, setGetFriends] = useState([]);
  const [friends, setFriends] = useState([]);

  const { selectedStore } = useSelector((store) => store.selectedStore);

  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleMessageModalToggle = () => {
    setIsMessageModalOpen(!isMessageModalOpen);
  };
  const closeModalHandler = () => {
    handleClose();
  };
  const handleMessageModal = (profile) => {
    if (profile === "PROFILE") {
      navigate(`/users/${user.data.id}/updateProfile`);
      setIsMessageModalOpen(false);
      handleClose();
    }
  };
  const handleShareList = async (friend_id) => {
    try {
      const sharedList = await shareList(
        user.accessToken,
        user.data.id,
        selectedStore.id,
        li.list_id,
        { friend_id }
      );
      if (sharedList.success) {
        setModalContent({
          title: "Note",
          description: sharedList.data,
          redButton: "OKAY",
        });
        const result = await getUserDashboard({
          store_id: selectedStore.id,
          user_id: user.data.id,
          token: user.accessToken,
        });
        if (result.data) {
          dispatch(setLists(result.data.lists));

          dispatch(setListItems(result.data.lists));
          dispatch(getDashboard(result.data));
          setIsMessageModalOpen(true);
        } else if (!result.success) {
          console.error(result.message);
        }
        setIsMessageModalOpen(true);
      } else {
        setModalContent({
          title: "Note",
          description: "This list is already shared with your friend.",
          redButton: "OKAY",
        });
        setIsMessageModalOpen(true);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      if (user && isOpen) {
        try {
          const result = await getAllFriends(user.accessToken, user.data.id);
          if (result) {
            const { userFriends, friends } = result.data;
            setGetFriends(userFriends);
            setFriends(friends);
          }
        } catch (error) {
          console.error(error);
        }
      }
    };

    fetchData();
  }, [user, isOpen]);

  return (
    <Dialog
      size="xs"
      open={isOpen}
      handler={closeModalHandler}
      className="bg-transparent shadow-none"
    >
      <div className={`relative border-none  `}>
        <Card className={`modal-card mx-auto mt-8 overflow-auto`}>
          <CardBody className="flex flex-col gap-4">
            <div className="flex items-center justify-between">
              <Typography variant="h4" color="blue-gray">
                {shareListModalData.title}
              </Typography>
              <div className="flex items-center justify-center gap-4">
                <div
                  className="flex items-center justify-center w-6 h-6 bg-red-700 rounded-full"
                  onClick={closeModalHandler}
                >
                  <IoClose size={20} className="font-bold text-white" />
                </div>
              </div>
            </div>
            {friends && friends.length > 0 ? (
              friends.map((friend, id) => {
                let member;
                if (friend.status === "Pending") {
                  member = getFriends?.find(
                    (userFriend) =>
                      userFriend.id === friend.request_initiated_by
                  );
                } else if (
                  friend.status === "Approved" &&
                  friend.request_initiated_by === user.data.id
                ) {
                  member = getFriends?.find(
                    (userFriend) => userFriend.id === friend.request_to
                  );
                } else if (
                  friend.request_initiated_by !== user.data.id &&
                  friend.status === "Approved"
                ) {
                  member = getFriends?.find(
                    (userFriend) =>
                      userFriend.id === friend.request_initiated_by
                  );
                }
                return (
                  <div
                    className={`flex w-full items-center justify-between lg:gap-4 h-20 px-2 py-2 text-sm text-gray-900 border rounded-md shadow-xl lg:transition-transform duration-200 lg:ease-in-out lg:transform hover:scale-105 ${
                      friend?.status === "Pending" && member === undefined
                        ? "hidden"
                        : ""
                    } ${
                      friend?.status && friend.status === "Reject"
                        ? "hidden"
                        : ""
                    }`}
                    key={id}
                  >
                    <div
                      onClick={() => handleShareList(friend.id)}
                      className="flex items-center justify-center w-full gap-3 cursor-pointer "
                    >
                      <div className="w-10 ">
                        <img
                          className="object-contain w-10 h-10 rounded-full "
                          src={member?.photo_url ? member.photo_url : avatar}
                          alt="imageIcon"
                        ></img>
                      </div>
                      <div className=" lg:w-56 w-52">
                        <div className="text-sm font-bold sm:text-xm">
                          {member?.first_name} {member?.last_name}
                        </div>
                        <div className="text-xs break-words whitespace-normal">
                          {member?.email}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <Typography
                className="mb-3 font-normal"
                variant="paragraph"
                color="gray"
              >
                No Friends to share list with
              </Typography>
            )}
          </CardBody>
        </Card>

        {isMessageModalOpen && (
          <Modal
            modalData={modalContent}
            handleModalToggle={handleMessageModalToggle}
            isOpen={isMessageModalOpen}
            submitHandler={handleMessageModal}
          />
        )}
      </div>
    </Dialog>
  );
};
export default ShareList;
